import { parseVersionNumber } from '../parseVersionNumber'

/**
 * Returns the latest viable version: the non-archived version with the highest
 * version number.
 *
 * The versions endpoint returns the active version first, not the latest, so
 * the latest version must be derived from `versionNumber` rather than the list
 * position. Archived versions (with `archivedAt` populated) are excluded.
 */
export const getLatestVersion = <
  T extends { versionNumber: string; archivedAt?: string | null }
>(
  versions: T[]
): T | undefined =>
  versions
    .filter(version => !version.archivedAt)
    .reduce<T | undefined>(
      (latest, version) =>
        !latest ||
        parseVersionNumber(version.versionNumber) >
          parseVersionNumber(latest.versionNumber)
          ? version
          : latest,
      undefined
    )
